// extracted by mini-css-extract-plugin
export default {"ctaContainer":"promotion_ctaContainer__1xS6y"};